module.exports = "### May 17th, 2023 - [HOTFIX v1.4.5]\n\n- Update for v2.10.21415"